import { Typography } from "@mui/material";
import { Button } from "../../components/button/button";
import { LoginStyled } from "./login.style";
import GoogleIcon from "@mui/icons-material/Google";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { fetchUsers } from "../../services/usersServices"; // Import fetchUsers

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboards/user-dashboard";
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const users = await fetchUsers(); // Fetch all users

          const removeInactiveUsers = users.filter(
            (u) => u?.employmentStatus !== "Inactive"
          );

          const userData = removeInactiveUsers.find(
            (u) => u.email === user.email
          );

          if (!userData) {
            firebase.auth().signOut();
            alert("User not found. Please contact the administrator.");
            return;
          }

          // Check for employment status
          if (["Inactive"].includes(userData.employmentStatus)) {
            firebase.auth().signOut();
            alert(
              "Your account is inactive or contract-based. Please contact the administrator."
            );
            return;
          }

          // Check if the user's email is from the fka.agency domain
          if (
            user.email.endsWith("@fka.agency") ||
            user.email === "murtazasalimabbasi@gmail.com" ||
            user.email === "ilya@codeforhumans.dev"
          ) {
            console.log("User is authenticated with fka.agency domain");
            navigate(from);
          } else {
            firebase.auth().signOut();
            alert("You must use an @fka.agency email to log in.");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          firebase.auth().signOut();
          alert("An error occurred. Please try again later.");
        }
      } else {
        console.log("User is not authenticated");
      }
    });
  }, [navigate]);

  const onLogin = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log("User signed in:", result.user.email);
      })
      .catch((error) => {
        console.error("Login failed:", error.message);
      });
  };

  return (
    <LoginStyled>
      <div className="left">
        <Typography variant="h3">Flow</Typography>

        <div className="content">
          <div className="internal-flex">
            <Typography variant="h1">Welcome!</Typography>
            <div>Please sign in to your account.</div>
            <Button
              variant="outlined"
              startIcon={<GoogleIcon />}
              size="large"
              onClick={onLogin}
            >
              Log In with Google
            </Button>
          </div>
        </div>
      </div>
      <div className="right"></div>
    </LoginStyled>
  );
};

export default Login;
